/**
 * Jurisdictions (country codes) that have case / precedent indexes
 * available in Azure AI Search.
 *
 * Only GB (United Kingdom) and SE (Sweden) currently have dedicated
 * case-law search indexes; other jurisdictions only support statute/law retrieval.
 */
export const CASES_AVAILABLE_JURISDICTIONS = ['GB', 'SE', 'NL'];

/**
 * Check whether a given jurisdiction code supports case-law / precedent features.
 */
export const hasCasesSupport = (jurisdiction?: string | null): boolean => {
  if (!jurisdiction) return false;
  return CASES_AVAILABLE_JURISDICTIONS.includes(jurisdiction.toUpperCase());
};

/**
 * Static list of jurisdictions available in the platform.
 * Used by onboarding, settings, and matter creation forms.
 */
export const AVAILABLE_JURISDICTIONS = [
  { value: 'SE', label: 'Sweden' },
  { value: 'NO', label: 'Norway' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'ES', label: 'Spain' },
  { value: 'GB', label: 'United Kingdom' },
];
